<template>
  <div>
    <b-form-row class="align-items-center px-50 justify-content-between">
      <h4>أهداف المشروع</h4>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12">
        <b-list-group class="rounded border">
          <b-list-group-item class="bg-secondary bg-lighten-3">
            <b-form-row class="text-white">
              <b-col> هدف المشروع</b-col>

              <b-col> </b-col>
            </b-form-row>
          </b-list-group-item>
          <template v-if="loadingRecords">
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>جاري التحميل...</strong>
            </div>
          </template>
          <template v-else>
            <template v-if="records.length === 0 && !isAdding">
              <span class="text-center my-1" style="opacity: 0.7"
                >لا يوجد سجلات حتى الآن</span
              >
            </template>
            <b-list-group-item v-for="(goal, index) in records" :key="index">
              <validation-observer
                v-if="isEdit === goal.id"
                ref="EditFormValidation"
              >
                <b-form @submit.prevent="onSubmit(index)">
                  <b-form-row>
                    <b-col>
                      <form-input
                        label="هدف المشروع"
                        rules="required"
                        v-model="toAdd.name"
                      />
                    </b-col>

                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isEdit = null"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
              <b-form-row v-else class="align-items-center">
                <b-col> {{ goal.name }}</b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="openActivitiesModal(goal.id)"
                    variant="flat-info"
                  >
                    الأنشطة
                  </b-button>
                  <b-button
                    @click="onEditClicked(goal, index)"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    @click="onDeleteClicked(goal.id)"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <validation-observer ref="FormValidation">
                <b-form @submit.prevent="onSubmit">
                  <b-form-row>
                    <b-col>
                      <form-input
                        label="هدف المشروع"
                        rules="required"
                        v-model="toAdd.name"
                      />
                    </b-col>

                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isAdding = false"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-form-row class="px-50 mt-1 d-flex justify-content-end">
          <b-button @click="onNewClicked" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-form-row>
      </b-col>
    </b-form-row>
    <project-activites
      :projectId="projectId"
      :goalId.sync="goalId"
      v-model="isActivitiesModalOpened"
    />
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BFormRow,
  BCol,
  BForm,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import FormDatepicker from "@/components/form-datepicker";
import FormCleave from "@/components/FormCleave.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import tableEditMixin from "../mixins/TableEditMixin";
import ProjectActivites from "./ProjectActivities.vue";

export default {
  mixins: [tableEditMixin],
  components: {
    FormInput,
    BButton,
    BFormGroup,
    BSpinner,
    BListGroup,
    BListGroupItem,
    BFormRow,
    BCol,
    LoaderBtn,
    BForm,
    ValidationObserver,
    FormSelect,
    FormDatepicker,
    FormCleave,
    Cleave,
    ProjectActivites,
  },
  data() {
    return {
      isActivitiesModalOpened: false,
      goalId: null,
    };
  },
  computed: {
    fetchEndpoint() {
      return `v2/co-op/project/${this.$route.params.id}/objectives`;
    },
    operationsEndpoint() {
      return `v2/co-op/project/objectives`;
    },
  },

  watch: {
    isActivitiesModalOpened(val) {
      if (!val) this.refreshData();
    },
  },
  methods: {
    openActivitiesModal(id) {
      this.goalId = id;
      this.isActivitiesModalOpened = true;
    },
  },
};
</script>
